import { render, staticRenderFns } from "./ProformCategoryPopup.vue?vue&type=template&id=6fe0fb7a&scoped=true"
import script from "./ProformCategoryPopup.vue?vue&type=script&lang=js"
export * from "./ProformCategoryPopup.vue?vue&type=script&lang=js"
import style0 from "./ProformCategoryPopup.vue?vue&type=style&index=0&id=6fe0fb7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe0fb7a",
  null
  
)

export default component.exports